import { getField, updateField } from 'vuex-map-fields';

export default {
  namespaced: true,
  state: {
    formValid: true,
    dataModel: [
      {
        relationship: "self",
        fname: "",
        lname:"",
        name : "",
        gender: "",
        isLiving: true,
        age: 0,
        isgeneTest: "No",
        isCancer: false,
        cancerConditions: [],
        cancerConditionsDx: {},
        geneTestDetail: {
          geneName: "",
          mutationName: "",
          labName: "",testName : "",
        },
        cancerOther: "",
        notes: "",
      },
      {
        relationship: "mom",
        name: "mom",
        gender: "Female",
        isLiving: true,
        age: 0,
        isgeneTest: "No",
        isCancer: false,
        cancerConditions: [],
        cancerConditionsDx: {},
        geneTestDetail: {
          geneName: "",
          mutationName: "",
          labName: "",testName : "",
        },
        cancerOther: "",
        notes: "",
      }, {
        relationship: "dad",
        name: "dad",
        gender: "Male",
        isLiving: true,
        age: 0,
        isgeneTest: "No",
        isCancer: false,
        cancerConditions: [],
        cancerConditionsDx: {},
        geneTestDetail: {
          geneName: "",
          mutationName: "",
          labName: "",testName : "",
        },
        cancerOther: "",
        notes: "",
      },
      {
        relationship: "maternal grandfather",
        name: "maternal grandfather",
        gender: "Male",
        isLiving: true,
        age: 0,
        isgeneTest: "No",
        isCancer: false,
        cancerConditions: [],
        cancerConditionsDx: {},
        geneTestDetail: {
          geneName: "",
          mutationName: "",
          labName: "",testName : "",
        },
        cancerOther: "",
        notes: "",
      },
      {
        relationship: "maternal grandmother",
        name: "maternal grandmother",
        gender: "Female",
        isLiving: true,
        age: 0,
        isgeneTest: "No",
        isCancer: false,
        cancerConditions: [],
        cancerConditionsDx: {},
        geneTestDetail: {
          geneName: "",
          mutationName: "",
          labName: "",testName : "",
        },
        cancerOther: "",
        notes: "",
      },
      {
        relationship: "paternal grandfather",
        name: "paternal grandfather",
        gender: "Male",
        isLiving: true,
        age: 0,
        isgeneTest: "No",
        isCancer: false,
        cancerConditions: [],
        cancerConditionsDx: {},
        geneTestDetail: {
          geneName: "",
          mutationName: "",
          labName: "",testName : "",
        },
        cancerOther: "",
        notes: "",
      },
      {
        relationship: "paternal grandmother",
        name: "paternal grandmother",
        gender: "Female",
        isLiving: true,
        age: 0,
        isgeneTest: "No",
        isCancer: false,
        cancerConditions: [],
        cancerConditionsDx: {},
        geneTestDetail: {
          geneName: "",
          mutationName: "",
          labName: "",testName : "",
        },
        cancerOther: "",
        notes: "",
      }
    ],
    GeneticTrustdataModel: [
      {
        relationship: "self",
        fname: "",
        lname: "",
        mname: "",
        address: "",
        gender: "",
        phone: "",
        email: "",
        isLiving: true,
        age: 0,
        isgeneTest: "No",
        healthCondition: [],
        isCancer: false,
        cancerConditions: [],
        cancerConditionsDx: {},
        geneTestDetail: {
          geneName: "",
          mutationName: "",
          labName: "",testName : "",
        },
        cancerOther: "",
        notes: "",
      },
      {
        relationship: "mom",
        name: "mom",
        gender: "Female",
        isLiving: true,
        age: 0,
        isgeneTest: "No",
        isCancer: false,
        cancerConditions: [],
        cancerConditionsDx: {},
        geneTestDetail: {
          geneName: "",
          mutationName: "",
          labName: "",testName : "",
        },
        cancerOther: "",
        notes: "",
      }, {
        relationship: "dad",
        name: "dad",
        gender: "Male",
        isLiving: true,
        age: 0,
        isgeneTest: "No",
        isCancer: false,
        cancerConditions: [],
        cancerConditionsDx: {},
        geneTestDetail: {
          geneName: "",
          mutationName: "",
          labName: "",testName : "",
        },
        cancerOther: "",
        notes: "",
      },
      {
        relationship: "maternal grandfather",
        name: "maternal grandfather",
        gender: "Male",
        isLiving: true,
        age: 0,
        isgeneTest: "No",
        isCancer: false,
        cancerConditions: [],
        cancerConditionsDx: {},
        geneTestDetail: {
          geneName: "",
          mutationName: "",
          labName: "",testName : "",
        },
        cancerOther: "",
        notes: "",
      },
      {
        relationship: "maternal grandmother",
        name: "maternal grandmother",
        gender: "Female",
        isLiving: true,
        age: 0,
        isgeneTest: "No",
        isCancer: false,
        cancerConditions: [],
        cancerConditionsDx: {},
        geneTestDetail: {
          geneName: "",
          mutationName: "",
          labName: "",testName : "",
        },
        cancerOther: "",
        notes: "",
      },
      {
        relationship: "paternal grandfather",
        name: "paternal grandfather",
        gender: "Male",
        isLiving: true,
        age: 0,
        isgeneTest: "No",
        isCancer: false,
        cancerConditions: [],
        cancerConditionsDx: {},
        geneTestDetail: {
          geneName: "",
          mutationName: "",
          labName: "",testName : "",
        },
        cancerOther: "",
        notes: "",
      },
      {
        relationship: "paternal grandmother",
        name: "paternal grandmother",
        gender: "Female",
        isLiving: true,
        age: 0,
        isgeneTest: "No",
        isCancer: false,
        cancerConditions: [],
        cancerConditionsDx: {},
        geneTestDetail: {
          geneName: "",
          mutationName: "",
          labName: "",testName : "",
        },
        cancerOther: "",
        notes: "",
      }
    ],
    snackbar: false,
    genderList: ["Male", "Female", "Transgender Male", "Transgender Female",  "Gender variant/non-conforming"],
    cancerList: [
      "Breast",
      "Ovarian",
      "Uterine",
      "Colorectal",
      "Prostate",
      "Skin",
      "Pancreatic",
      "Lung",
      "Cervical",
      "Testicular",
      "Esophageal",
      "Throat",
      "Head and Neck",
      "Bladder",
      "Thyroid",
      "Kidney",
      "Brain/CNS",
      "Neuroendocrine",
      "Other"
    ],
    errorText: null,
  },

  getters: {
    getField,
  },
  mutations: {
    updateField,
  },
  actions: {}

}